@if (isVisible()) {
    <nav
        class="dock"
        [class.minimized]="minimized()"
        aria-label="Application utilities"
    >
        @for (action of actions(); track action.key) {
            <button
                qpxButton
                matButton
                size="sm"
                [class]="`action ${action.className ?? ''}`"
                [class.icon-only]="minimized()"
                [attr.aria-controls]="action.ariaControls ?? null"
                [attr.aria-description]="action.badgeDescription ?? null"
                [attr.aria-expanded]="action.ariaExpanded ?? null"
                [attr.aria-haspopup]="action.ariaHasPopup ?? null"
                [attr.aria-label]="action.ariaLabel ?? action.label"
                [attr.data-utility-action-key]="action.key"
                [qpxTooltip]="action.label"
                [matTooltipDisabled]="!minimized()"
                (click)="action.onClick()"
            >
                @if (action.badgeMode === 'dot') {
                    <span
                        class="badge-dot mat-icon"
                        aria-hidden="true"
                        matButtonIcon
                    ></span>
                } @else if (action.animatedIcon; as animatedIcon) {
                    <qpx-animated-icon
                        [name]="animatedIcon.name"
                        [active]="animatedIcon.active"
                        matButtonIcon
                    />
                } @else if (action.icon; as icon) {
                    <ng-icon qpx [name]="icon" matButtonIcon />
                }
                @if (!minimized()) {
                    <span>{{ action.label }}</span>
                }
            </button>
        }

        @if (showRealtimeDiagnostics) {
            @defer (on immediate) {
                <qpx-realtime-debug-panel [compact]="minimized()" />
            }
            @defer (on immediate) {
                <qpx-theme-debug-panel [compact]="minimized()" />
            }
        }

        @if (showFeatureFlagDiagnostics()) {
            @defer (on immediate) {
                <qpx-feature-flag-debug-panel [compact]="minimized()" />
            }
        }

        <span class="divider" aria-hidden="true"></span>

        <button
            qpxButton
            matButton
            size="sm"
            class="toggle icon-only"
            [attr.aria-label]="minimizeLabel()"
            [qpxTooltip]="minimizeLabel()"
            (click)="toggleMinimized()"
        >
            <ng-icon
                qpx
                [name]="minimized() ? 'lucideMaximize' : 'lucideMinimize'"
                matButtonIcon
            />
        </button>
    </nav>
}
